const pipelineConfig = {
  BASE_URL: "https://api.dev.syncrosale.com",
  KC_HOST: "https://auth.dev.syncrosale.com/",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "dev",
};

const devConfig = {
  BASE_URL: "https://api.dev.syncrosale.com",
  KC_HOST: "https://auth.dev.syncrosale.com",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "dev",
};

const localConfig = {
  BASE_URL: "http://localhost:8081",
  KC_HOST: "http://localhost:8080",
  KC_REALM: "syncrosale",
  KC_CLIENT_ID: "syncrosale",
  ENV: "dev",
};

export const config = pipelineConfig.BASE_URL.startsWith("%%")
  ? devConfig
  : pipelineConfig;
